export enum SocialMediaType {
  Facebook = 'facebook',
  Youtube = 'youtube',
  LinkedIn = 'linkedIn',
  X = 'x',
  TikTok = 'tiktok',
  Instagram = 'instagram',
}
